import { Stack, Typography } from "@mui/material";
import { FC } from "react";

import { EMPTY_STR } from "@/constants/string";
import { text, background, divider } from "@/theme/colors";
import { formatYen } from "@/features/organization/product/utils/productUtils";

type TPriceSummaryBarProps = {
  /** 単価（税抜）. */
  basePrice: number | null;
  /** 値引き（特定2号）. */
  discount: number | null;
};

/**
 * 基本単価 ｜ 値引き（特定2号）｜ 小計 summary line, derived from 単価（税抜）and 値引き（特定2号）(C8):
 *  - each value shows its source, or "-" when that source is empty
 *  - 小計 = 基本単価 − 値引き; shows "-" when either input is empty
 *  - when both inputs are empty, all three show "-"
 */
export const PriceSummaryBar: FC<TPriceSummaryBarProps> = ({ basePrice, discount }) => {
  const baseText = formatYen(basePrice);
  const discountText = formatYen(discount);
  const subtotalText = basePrice == null || discount == null ? EMPTY_STR.TEXT : formatYen(basePrice - discount);

  const items: [string, string][] = [
    ["基本単価", baseText],
    ["値引き（特定2号）", discountText],
    ["小計", subtotalText],
  ];

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      sx={{
        bgcolor: background.primary,
        borderRadius: 2,
        px: 2,
        py: 1.25,
        flexWrap: "wrap",
        border: `1px solid ${divider.middle}`
      }}
    >
      {items.map(([label, value], i) => (
        <Stack key={label} direction="row" alignItems="center" gap={2}>
          {i > 0 && <Typography color={text.tertiary}>｜</Typography>}
          <Typography variant="body14Semi" color={text.secondary}>
            {label}：<Typography component="span" variant="body14" color={text.primary}>{value}</Typography>
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
